<template>
	<type-wrapper class="type-O" limit>
		<type-grid row="1" margin center>
			<type-title large weight="normal" v-if="showData.name">{{ showData.name }}</type-title>
		</type-grid>
		<type-grid row="1" margin v-for="(items, index) in (showData.data || [])" :key="index" style="border-bottom: 1px solid #000000;">
			<type-title medium weight="normal" left v-if="items.edd" @click="items.isShow = !items.isShow" class="type-O-shrink-title">
				<my-icon size="24px" color="#000000" style="margin-right: 6px;" :icon="items.isShow ? 'down' : 'right'"></my-icon>
                <div class="type-O-title">{{ items.edd }}</div>
			</type-title>
			<div v-show="items.isShow">
				<type-grid row="1" margin v-for="(item, i) in (items.su || [])" :key="i">
					<type-title small weight="normal" left v-if="item.ed" @click="item.isShow = !item.isShow" class="type-O-shrink-title">
						<my-icon size="20px" color="#000000" style="margin-right: 10px;" :icon="item.isShow ? 'down' : 'right'"></my-icon>
						<div class="type-O-title">{{ item.ed }}</div>
					</type-title>
					<type-content small v-show="item.isShow && item.tg" padding="0 0 20px 40px">{{ item.tg }}</type-content>
				</type-grid>
			</div>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 常见问题
	import mixin from '../mixin.js'
	export default {
		name: 'type-O',
		mixins: [ mixin ]
	}
</script>

<style scoped lang="less">
	.type-O{
		.type-O-shrink-title{
			display: flex;
			.type-O-title{
				display: inline-flex;
				width: calc(100% - 30px);
			}
		}
	}
</style>
